import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Badge component for status indicators and labels
 */
const Badge = React.forwardRef(({
    variant = 'default',
    className,
    children,
    ...props
}, ref) => {
    const variantClasses = {
        default: 'badge bg-gray-100 text-gray-800',
        primary: 'badge-primary',
        success: 'badge-success',
        warning: 'badge-warning',
        error: 'badge-error',
        secondary: 'badge bg-gray-100 text-gray-600',
    };

    return (
        <span
            ref={ref}
            className={cn(
                variantClasses[variant],
                className
            )}
            {...props}
        >
            {children}
        </span>
    );
});

Badge.displayName = 'Badge';

export default Badge;